/*
 * @Author: Teemo Ding
 * @Date: 2021-09-07 16:55:00
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 11:15:33
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/OrderEligibleSection/index.tsx
 */
import React from 'react';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import OrderEligible from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/OrderEligibleCondition';
import css from '../css.module.less';
// const Item = Form.Item;
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const OrderEligibleSection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { form, currency, disableEdit, onEveryoneSelected } = props;
  return (
    <SectionWrapper
      className={css.sectionContainer}
      title={getI18n(
        'salesChannelDirectDiscount.orderEligibleSection.orderEligibleCondition',
      )}
      subtitle={getI18n(
        'salesChannelDirectDiscount.eligibalCondition.conditionTip',
      )}>
      <OrderEligible
        name={'conditions'}
        form={form}
        currency={currency}
        disableEdit={disableEdit}
        onEveryoneSelected={onEveryoneSelected}
      />
    </SectionWrapper>
  );
};

export default OrderEligibleSection;
